export interface LocaleDict {
  en: string
  de: string
  tr: string
  bg: string
  ro: string
  ru: string
  fr: string
  uk: string
  ar: string
}

export interface LocaleAltDict {
  en?: string
  de?: string
  tr?: string
  bg?: string
  ro?: string
  ru?: string
  fr?: string
  uk?: string
  ar?: string
}

export enum Locale {
  English = 'en',
  German = 'de',
  Turkish = 'tr',
  Bulgarian = 'bg',
  Romanian = 'ro',
  Russian = 'ru',
  French = 'fr',
  Ukrainian = 'uk',
  Arabic = 'ar',
}

export const LocaleKeys = ['en', 'de', 'tr', 'bg', 'ro', 'ru', 'fr', 'uk', 'ar', ]

export function GenerateLocaleDict(dict: LocaleAltDict = {}): LocaleDict {
  return {
    en: dict.en || '',
    de: dict.de || '',
    tr: dict.tr || '',
    bg: dict.bg || '',
    ro: dict.ro || '',
    ru: dict.ru || '',
    fr: dict.fr || '',
    uk: dict.uk || '',
    ar: dict.ar || '',
  }
}

export function AssertLocaleDict(
  dict: LocaleDict | null | undefined
): LocaleDict {
  return dict || GenerateLocaleDict()
}
